import { Select } from 'antd';
import * as React from 'react';

export interface ILanguageSelectProps {
  name: string;
  onChange: (e: any, language: GQL.ILanguage | undefined) => void;
  value: string | undefined;
  languages?: Array<GQL.ILanguage>;
  style?: any;
}

export class LanguageSelect extends React.PureComponent<ILanguageSelectProps> {

  constructor(props: ILanguageSelectProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  public render() {
    const { value, onChange, style, languages } = this.props;

    if (languages) {
      return (
        <Select
          onChange={this.onChange}
          value={value}
          style={...style}
        >
          {languages.map(l => {
            return (
              <Select.Option key={l.id} value={l.id}>
                {l.value}
              </Select.Option>
            );
          })}
        </Select>
      );
    }

    return (
      <Select onChange={k => onChange(k as string, undefined)} value={value} style={...style}>
        <Select.Option value="en">en</Select.Option>
        <Select.Option value="cs">cs</Select.Option>
      </Select>
    );
  }

  private onChange(value: string) {
    const { languages } = this.props;

    const language = languages && languages.find((l: GQL.ILanguage) => l.id === value);

    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value,
        }
      }, language);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Others/LanguageSelect/LanguageSelect.tsx